import { render, staticRenderFns } from "./update-paperpile-details.html?vue&type=template&id=4c2e70a8&scoped=true&external"
import script from "./update-paperpile-details.js?vue&type=script&lang=js&external"
export * from "./update-paperpile-details.js?vue&type=script&lang=js&external"
import style0 from "./update-paperpile-details.scss?vue&type=style&index=0&id=4c2e70a8&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2e70a8",
  null
  
)

export default component.exports